// import BigNumber from 'bignumber.js';

// function transferToNumber(inputNumber) {
//   if (isNaN(inputNumber * 1)) {
//     return inputNumber;
//   }
//   inputNumber = '' + inputNumber;
//   inputNumber = parseFloat(inputNumber);
//   let eformat = inputNumber.toExponential(); // 转换为标准的科学计数法形式（字符串）
//   let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值
//   let number = inputNumber.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]));
//   return number;
// }
export function decodeHtmlEntities(input) {
    if (!input || input?.trim() == "") return "";
    const textarea = document.createElement("textarea");
    textarea.innerHTML = input || "";
    const text = textarea.value;
    return text;
}

export function compareVersion(version1, version2) {
    const arr1 = version1.split(".");
    const arr2 = version2.split(".");
    const length1 = arr1.length;
    const length2 = arr2.length;
    const minlength = Math.min(length1, length2);
    let i = 0;
    for (i; i < minlength; i++) {
        const a = parseInt(arr1[i]);
        const b = parseInt(arr2[i]);
        if (a > b) {
            return 1;
        } else if (a < b) {
            return -1;
        }
    }
    if (length1 > length2) {
        for (let j = i; j < length1; j++) {
            if (parseInt(arr1[j]) != 0) {
                return 1;
            }
        }
        return 0;
    } else if (length1 < length2) {
        for (let j = i; j < length2; j++) {
            if (parseInt(arr2[j]) != 0) {
                return -1;
            }
        }
        return 0;
    }
    return 0;
}

export function isPromise(obj) {
    return obj && typeof obj.then === "function";
}

// //后面在想办法加点新的东西
// export const getIM = (function () {
//   let IM = localStorage.IM;
//   return function () {
//     if (IM) return IM;
//     IM =
//       (window.navigator.userAgent || '')
//         .replace(/ /g, '')
//         .replace(/[`~%!@#^=''?~《》！@#￥……&——‘”“'？*()（），,。.、<>]/g, '')
//         .split('')
//         .sort()
//         .join('') + new Date().getTime();
//     localStorage.IM = IM;
//     return localStorage.IM;
//   };
// })();

// export const moneyFormat = (money, decimalCount = 2, groupSize = 3) => {
//   if (!money) return '0.'.padEnd(2 + decimalCount, '0');

//   const _money = new BigNumber(money);

//   if (_money.isNaN()) return '0.'.padEnd(2 + decimalCount, '0');
//   return _money.toFormat(decimalCount, BigNumber.ROUND_DOWN, {
//     decimalSeparator: '.',
//     groupSeparator: ',',
//     groupSize,
//   });
// };

// export const contentType = contentType => {
//   // 0 文本 1 图片 2 视频 3 音频 4 未知
//   if (contentType.startsWith('text/')) {
//     return 0;
//   } else if (contentType.startsWith('image/')) {
//     return 1;
//   } else if (contentType.startsWith('video/')) {
//     return 2;
//   } else if (contentType.startsWith('audio/')) {
//     return 3;
//   } else {
//     return 4;
//   }
// };

// export const addressFormat = (address, prefixCount = 6, pointCount = 6, suffixCount = 6) => {
//   const _address = (address || '').trim();

//   if (!_address) return '';

//   let pointText = '';
//   for (let i = pointCount; i > 0; i--) {
//     pointText += '.';
//   }

//   return _address.slice(0, prefixCount) + pointText + _address.slice(-suffixCount);
// };

// export const getUuid = (function () {
//   var id = 0;
//   return () => 'timer_' + new Date().getTime() + '_' + id++;
// })();
// // 处理千分符
// export const addCommas = num => {
//   var str = num.toString().split('.');
//   if (str[0].length >= 4) {
//     str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
//   }
//   if (str[1] && str[1].length >= 5) {
//     str[1] = str[1].replace(/(\d{3})/g, '$1');
//   }
//   return str.join('.');
// };

// export const InitTime = (time, len = 0) => {
//   if (typeof time === 'string') {
//     time = new Date(time).getTime();
//   }
//   var date = time * 1 >= 1000000000000 ? new Date(time + 8 * 3600 * 1000) : new Date(time * 1000 + 8 * 3600 * 1000);
//   return date
//     .toJSON()
//     .substr(len || 0, 19 - len)
//     .replace('T', ' ');
// };

// export const getFullNum = num => {
//   try {
//     //处理非数字
//     if (isNaN(num)) {
//       return num;
//     }
//     if (!num) {
//       return 0;
//     }

//     //处理不需要转换的数字
//     var str = '' + num;
//     if (!/e/i.test(str)) {
//       return num;
//     }

//     return num.toFixed(18).replace(/\.?0+$/, '');
//   } catch (error) {
//     return 0;
//   }
// };
// export const writeMoneyAndSymbol = function (money) {
//   let def = '--';
//   if (money == null || money === '') return def;
//   money = money + '';
//   try {
//     let t = money.split('.');
//     if (t.length === 1) {
//       if (money.length <= 3) {
//         return money + '.00';
//       } else {
//         money = String(parseInt(t[0])).replace(/,/g, '');
//         return addCommas(money);
//       }
//     }
//     let start = t[0],
//       end = t[1];
//     let count = 6;
//     //将整数位用千分符','分割
//     if (start.length > 3) {
//       start = String(parseInt(start)).replace(/,/g, '');
//       //切分后字符个数增加一位
//       count += 1;
//     }
//     if (start.length >= count) return addCommas(start);
//     return addCommas(start + '.' + end.substring(0, count - start.length));
//   } catch (e) {
//     console.error('格式化money ==失败==>' + money);
//     console.error(e);
//     return money;
//   }
// };
// export const setTheme = isDark => {
//   let app = document.getElementById('app');
//   const body = document.getElementsByTagName('body')[0];
//   let className = isDark ? 'theme-dark' : 'theme-light';
//   body.setAttribute('class', className);
//   app.setAttribute('class', className);
// };

// export function getAppVersionForUa() {
//   const ua = window.navigator.userAgent.toLowerCase();
//   // eslint-disable-next-line
//   let match = ua.toLowerCase().match(/bitkeep\s+[a-zA-Z]+\/([\d\.]+)/);
//   if (match) {
//     return match[1];
//   }
//   return '';
// }
// export function compareVersion(version1, version2) {
//   const v1 = version1.split('.');
//   const v2 = version2.split('.');
//   for (let i = 0; i < v1.length || i < v2.length; ++i) {
//     let x = 0,
//       y = 0;
//     if (i < v1.length) {
//       x = parseInt(v1[i]);
//     }
//     if (i < v2.length) {
//       y = parseInt(v2[i]);
//     }
//     if (x > y) {
//       return 1;
//     }
//     if (x < y) {
//       return -1;
//     }
//   }
//   return 0;
// }

// export default {
//   scrollIntoView: scrollIntoView,
//   transferToNumber: transferToNumber,
//   DPR,
//   parseUA,
//   getAppVersionForUa,

//   InitTime,
//   UpperCase,
//   LowerCase,
//   getFullNum,
//   compareVersion,
// };

export function isUxuyMobile() {
    const ua = window?.navigator?.userAgent;
    return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            ua
        ) && /(UXUY)/i.test(ua)
    );
}

export function DPR() {
    if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
    }
    return 1;
}

export const UpperCase = (str = "") => {
    return (str || "").toUpperCase();
};

export const LowerCase = (str = "") => {
    return (str || "").toLowerCase();
};
export const parseUA = () => {
    const ua = navigator.userAgent || window.navigator.userAgent;
    const isIosEnv = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    const isPhonx = () =>
        !!(
            isIosEnv &&
            window.screen.height == 812 &&
            window.screen.width == 375
        );

    const ret = {
        ios: isIosEnv,
        android: ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1,
        Mobile: /(Mobile)/i.test(ua),
        // MobileAll: ua.indexOf('Android') > -1 || ua.indexOf('iPhone') > -1 || ua.indexOf('SymbianOS') > -1 || ua.indexOf('Windows Phone') > -1 || ua.indexOf('iPad') > -1 || ua.indexOf('iPod') > -1,
        wPhone: /(Windows Phone|windows[\s+]phone)/i.test(ua),
        PC:
            ua.indexOf("Win") > -1 ||
            ua.indexOf("Mac") > -1 ||
            ua.indexOf("Linux") > -1,
        weixin: ua.indexOf("MicroMessenger") > -1,
        isDinhgDing: /(DingTalk)/i.test(ua),
        isUxuyMobile: isUxuyMobile(),
    };
    ret.os = ret.ios
        ? "ios"
        : ret.android
          ? "android"
          : ret.wPhone
            ? "wPhone"
            : ret.PC
              ? "pc"
              : "unKnow";
    ret.uxuyAndroid = ret.isUxuyMobile && ret.android;
    ret.uxuyIos = ret.isUxuyMobile && ret.ios;
    console.log("UA.....", ret);
    return Object.assign(ret, { isPhonx: isPhonx() });
};
export function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;

        if (timeout) clearTimeout(timeout);

        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait || 200);
    };
}

export const throttle = (fn, delay) => {
    let timer = null;
    // var delay = delay || 300;
    return function () {
        const args = arguments;
        const that = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
};
export const scrollIntoView = throttle(function (scrollIntoEl, options) {
    scrollIntoEl &&
        scrollIntoEl.scrollIntoView &&
        scrollIntoEl.scrollIntoView(
            options || {
                behavior: "smooth",
                block: "center",
            }
        );
}, 300);

export function transfer16(val: string | number = 0) {
    val = isNaN(Number(val)) ? Number(-1) : Number(val);
    return "0x" + val.toString(16);
}

export function compareToken(token1, token2) {
    const addr1 = token1?.addr?.length > 3 ? token1.addr.toLowerCase() : "";
    const addr2 = token2?.addr?.length > 3 ? token2.addr.toLowerCase() : "";

    const chainKey1 = token1.chainKey;
    const chainKey2 = token2.chainKey;

    const isSomeChain =
        chainKey1 == chainKey2 ||
        (token1?.chainId &&
            transfer16(token1?.chainId) == transfer16(token2?.chainId));

    return isSomeChain && addr1 == addr2;
}

/**
 * {
 *  type,
 *  params
 * }
 * toDownLoad
 */
export const goToApp = (function () {
    let timer = null;
    let eventCallBack = null;

    function visibilitychange(...arg) {
        const tag = document.hidden || document.webkitHidden;
        eventCallBack && eventCallBack(tag);
        if (tag) {
            clearTimeout(timer);
        }
    }
    function pagehide() {
        eventCallBack && eventCallBack(true);
        clearTimeout(timer);
    }

    window.addEventListener("visibilitychange", visibilitychange);
    window.addEventListener("pagehide", pagehide);

    return function ({ type, params }, toDownLoad = true, callBack) {
        clearTimeout(timer);
        const isUxuyWebview = isUxuyMobile();
        let link = "uxuy://";
        const uxuylaunchScheme = "uxuy://launch";
        const uxuyWebviewScheme = "uxuy://webview";
        eventCallBack = callBack;

        switch (type) {
            case "webview": //跳转内部浏览器
                link = `${uxuyWebviewScheme}?url=${params.url}`;
                break;
            case "launch": // 跳转外部浏览器
                link = `${uxuylaunchScheme}?url=${params.url}`;
                break;
            case "transfer_detail": // 跳转外部浏览器
                link = `uxuy://transfer_detail?txId=${params.txId}&chainId=${params.chainId}&address=${params.address}`;
                break;
            case "swap_order_detail": // 跳转外部浏览器
                link = `uxuy://swap_order_detail?orderId=${params.id}`;
                break;
            case "market_quote_detail": // 跳转外部浏览器
                link = `uxuy://market_quote_detail?chainid=${params.chainId}&address=${params.address} `;
                break;
            case "swap/utrade": // 跳转外部浏览器
                link = `uxuy://go_swap?fromChainId=${params.fromChainId}&fromAddress=${params.fromAddress || "0x0000000000000000000000000000000000000000"}&toChainId=${params.toChainId || 1}&toAddress=${
                    params.toAddress ||
                    "0x0000000000000000000000000000000000000000"
                } `;
                break;
            default:
                link = "uxuy://";
                break;
        }
        // case "twitter_status": // 跳转外部浏览器
        // link = `twitter://status?id=${1732404893124866373}`
        // break;

        if (isUxuyWebview) {
            window.location.href = link;
            return;
        }
        if (!toDownLoad) return;

        timer = setTimeout(() => {
            window.location.href = `https://uxuy.com/download`;
        }, 3000);
        return () => {
            clearTimeout(timer);
            window.removeEventListener("visibilitychange", visibilitychange);
            window.removeEventListener("pagehide", pagehide);
            timer = null;
        };
    };
})();

export const goToTwitterApp = (function () {
    let timer = null;
    let eventCallBack = null;

    function visibilitychange(...arg) {
        const tag = document.hidden || document.webkitHidden;
        eventCallBack && eventCallBack(tag);
        if (tag) {
            clearTimeout(timer);
        }
    }
    function pagehide() {
        eventCallBack && eventCallBack(true);
        clearTimeout(timer);
    }

    window.addEventListener("visibilitychange", visibilitychange);
    window.addEventListener("pagehide", pagehide);

    return function ({ type, params }, callBack) {
        clearTimeout(timer);
        const isUxuyWebview = isUxuyMobile();
        let schemelink = "twitter://";
        let webLink = "https://twitter.com/";
        eventCallBack = callBack;

        switch (type) {
            case "twitter_status": // 跳转指定的twitter文章
                schemelink = `twitter://status?id=${params.id}`;
                webLink = `https://twitter.com/${params.username}/status/${params.id}`;
                break;
            default:
                break;
        }
        if (isUxuyWebview) {
            console.log(schemelink, webLink);
            window.open(schemelink);
        } else {
            window.location.href = webLink;
        }

        timer = setTimeout(() => {
            if (isUxuyWebview) {
                window.location.href = webLink;
            } else {
            }
            clearTimeout(timer);
        }, 3000);
        return () => {
            clearTimeout(timer);
            window.removeEventListener("visibilitychange", visibilitychange);
            window.removeEventListener("pagehide", pagehide);
            timer = null;
        };
    };
})();

export const getTimeZone = function () {
    function getCurrentTimeZoneOffset() {
        const now = new Date();
        const offsetMinutes = now.getTimezoneOffset();
        const offsetHours = Math.abs(offsetMinutes) / 60;
        const offsetDirection = offsetMinutes > 0 ? "-" : "+";

        return `${offsetDirection}${String(offsetHours).padStart(2, "0")}:00`;
    }

    // if (window.Intl) {
    //   // 获取当前时区
    //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    //   console.log('当前时区：', timeZone);
    //   return timeZone
    // }
    try {
        const timeZone = getCurrentTimeZoneOffset();
        return timeZone;
    } catch (error) {
        return "";
    }
};

// export default {
//   DPR,
//   UpperCase,
//   LowerCase,
//   throttle,
//   debounce,
//   scrollIntoView,
//   parseUA
// }
/**
 *
 * 'dark' | 'light'
 *
 * @param {*} theme
 */
export function changeTheme(theme) {
    const domHtml = document.querySelector("html");
    domHtml?.setAttribute("data-theme", theme);
    // console.log('changeTheme', domHtml)
}

export function getRewCode(text) {
    if (!text) return "";

    const regex = /C2_(\w+)/;
    const match = text.match(regex);

    if (match && match[1]) {
        return match[1];
    } else {
        console.log("No match found.");
        return "";
    }

    return;
}

export function getDetailTextSize(totalLen) {
    const fS = 44;
    const lH = 53;
    const LEN = 12;
    let fontSize;
    let lineHeight;
    //const totalLen = ((amount || '') + (assets?.symbol || '')).length
    if (totalLen <= LEN) {
        fontSize = `${fS}px`;
        lineHeight = `${lH}px`;
    } else {
        fontSize = `${Math.max(LEN, fS - Math.ceil(totalLen / 1.3))}px`;
        lineHeight = `${Math.max(LEN, lH - Math.ceil(totalLen / 1.3))}px`;
    }
    return {
        fontSize,
        lineHeight,
    };
}

export const waitForPageLoad = () => {
    return new Promise((resolve) => {
        if (
            document.readyState === "complete" ||
            document.readyState === "interactive"
        ) {
            // 页面已经加载
            resolve(true);
        } else {
            // 等待 DOM 加载完成
            document.addEventListener("DOMContentLoaded", resolve);
        }
    });
};

export const timout = (time = 1000) => {
    return new Promise((_, reject) => setTimeout(reject, time));
};
